<template>
    <div id="customInput_main" class="ff-inter">
        <div id="customInput_input" @click="redirectFocus" class="bg-faded" :class="(info ? 'fc-main' : 'fc-gray-dark')" :key="dateKey">
            <i id="customInput_icon" class="fas" :class="icon"></i>
            <input :placeholder="placeholder" class="ff-inter fs-small fc-black customInput_editable" ref="customInput_editable" v-model="info" @keyup="change" @keydown="change" @change="change" :type="(hidden && !show) ? 'password' : 'text'">
            <div id="customInput_show" v-show="hidden" @click="toggleShow" :class="(show ? 'fc-main' : 'fc-gray-dark')">
                <i class="fas fa-eye"></i>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'customInput',
    props: {
      icon: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      hidden: {
        type: Boolean,
        default: false
      }
    },
    data(){
      return{
        info: '',
        show: false
      }
    },
    computed:{
      dateKey(){
        return new Date().toDateString()
      }
    },
    methods:{
      change(){
        this.$emit('input', this.info)
      },
      redirectFocus(){
        this.$refs.customInput_editable.focus()
      },
      toggleShow(){
        this.show = !this.show
      }
    },
    mounted () {

    }
  }
</script>

<style scoped>
    #customInput_main{
        display: flex;
        width: 100%;
    }
    #customInput_input{
        display: flex;
        height: 40px;
        width: 100%;
        margin: 5px;
        padding-left: 10px;
        padding-right: 10px;
        align-items: center;
        cursor: text;
        overflow: hidden;
        border: 1px solid var(--color-gray);
    }
    #customInput_icon{
        display: flex;
        width: 30px;
    }
    #customInput_input:focus{
        outline: none;
        border-color: var(--color-main);
    }
    .customInput_editable{
        display: flex;
        align-items: center;
        height: 20px;
        width: calc(100% - 20px);
        overflow: hidden;
        background-color: transparent;
        border: none;
    }
    .customInput_editable:focus{
        outline: none;
    }
    #customInput_placeholder{
        display: flex;
        position: absolute;
        margin-left: 30px;
    }
    #customInput_show{
        cursor: pointer;
    }
</style>
